import {TariffVertical, VerticalTariff} from 'src/shared/types'

import {mapVerticalRequirements} from './map-vertical-requirements'

/**
 * Нормализация вертикалей
 */
export function withCorrectVertical(verticals: TariffVertical[], selectedVertical?: VerticalTariff): VerticalTariff {
  const verticalsMap = mapVerticalRequirements(verticals)
  const values = Object.values(verticalsMap)
  const vertical = selectedVertical ? values.find(vertical => vertical.name === selectedVertical.name) : undefined

  if (vertical) {
    return Object.assign({}, vertical, selectedVertical)
  }

  const fallbackVertical: VerticalTariff = {
    name: 'express',
    requirements: {},
  }

  // Если вертикаль вообще не была выбрана, то выбираем первую из списка
  return values[0] || fallbackVertical
}
